import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { Grid } from "@mantine/core";
import { Controller, Control } from "react-hook-form";
import SelectCountry from "@/components/molecules/SelectInputs/SelectCountry";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";

interface CountryOfOriginProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const CountryOfOrigin: React.FC<CountryOfOriginProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading">
        {t("registerCompany:originCountry.title")}
      </Text>
      <Grid>
        <Grid.Col span={1} pr={0} mr={0}>
          <SVGAsset name="circle-questionmark" />
        </Grid.Col>
        <Grid.Col span={10} pl={0} ml={0}>
          <Text size="sm" color="secondary">
            {t("registerCompany:originCountry.reason")}
          </Text>
        </Grid.Col>
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={6}>
        <Controller
          name="partialCompany.countryCodeIso3"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <SelectCountry
              required
              data-testid={"country-of-origin-select"}
              id={"country-of-origin"}
              label={t("registerCompany:originCountry.selectCountry")}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
              valueKey="iso3"
              labelKey="name"
              value={value}
              onChange={onChange}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default CountryOfOrigin;
